export const GLOBAL_BASE_URL = process.env.GLOBAL_FACADE_SERVER_ADDRESS

export const BASE_URL = process.env.GLOBAL_FACADE_SERVER_ADDRESS

//===========================================store function api=========================================
export const EP_USER_LOGIN = '/api/login'
export const EP_USER_LOGIN_2FA = '/api/login/twofa'
export const EP_USER_SIGNUP = '/api/create/lead'
export const EP_VERIFY_LEAD_OTP = '/api/verify/otp/lead'
export const EP_USER_FORGOT_PASSWORD = '/forgot/password'
export const EP_ADMIN_LOGOUT = '/signout'
export const EP_GENERATE_2FA_QRCODE = '/generate/twofa/qrcode'
export const EP_VERIFY_2FA_QRCODE = '/verify/twofa/secret'
export const EP_DISABLE_2FA_QRCODE = '/disable/twofa'
export const EP_REGISTER_STEP1 = '/create/register/step/one'
export const EP_REGISTER_STEP4 = '/create/register/step/four'
export const EP_REGISTER_STEP5 = '/create/register/step/five'
export const EP_DELETE_DOC = '/delete/user/docs'
export const EP_GET_COUNTRIES_LIST = '/get/country/list'

export const EP_GET_ACCOUNT_PRIORITY_LIST = '/trading/account/priority'
//===========================================plugin function api=========================================
export const EP_CHANGE_PASSWORD = '/change/password'

export const EP_API_DASHBOARD_DATA = '/get/dashboard/data'
export const EP_GET_DASHBOARD_OTHER_DATA = '/get/dashboard/other/data'
export const EP_GET_TOTAL_CLIENT = "/get/dashboard/totalclient"
export const EP_GET_TOTAL_SUBIB = "/get/dashboard/subibdata"
export const EP_GET_DASHBOARD_CHART_DATA = '/get/dashboard/chartdata'

export const EP_GET_USER_PROFILE = '/get/user/profile'
export const EP_GET_TRADING_ACCOUNT_DETAIL = '/admin/get/account/details'

export const EP_GET_IB_LIST = '/admin/get/admins/list'
export const EP_GET_IB_DETAIL = '/admin/get/admins/details'

export const EP_GET_USER_LIST = '/admin/get/user/list'
export const EP_GET_USER_VIEW = '/admin/get/user/details'
export const EP_USER_COUNT = '/admin/user/count'

//import withdrawal method list
export const EP_GET_WITHDARWA_METHOD_LIST = '/get/withdrawal/payments'

//export const EP_WITHDRAWAL_METHODS 			    		= 				'/admin/get/withdrawal/methods'  

export const EP_GET_DEPOSIT_LIST = '/admin/get/deposit/list'
export const EP_GET_DEPOSIT_VIEW = '/admin/get/deposit/details'

export const EP_GET_BONUS_LIST = '/admin/get/bonus/list' 
export const EP_GET_BONUS_VIEW = '/admin/get/bonus/details'

export const EP_GET_USER_REGISTERATION_STEP_DATA = '/get/registration/data'

//export const EP_COMMISSION_HISTORY 			    		= 				'/admin/get/commissionHistory'
export const EP_COMMISSION_REQUEST = '/admin/commission/request/otp'

export const EP_GET_WITHDRAWAL_LIST = '/admin/get/withdrawal/list'
export const EP_GET_WITHDRAWAL_COMMISSION_LIST = '/admin/get/commissionHistory'
export const EP_GET_AFFILIATE_EARNINGS = '/admin/get/affiliateEarning'
export const EP_GET_WITHDRAWAL_VIEW = '/admin/get/withdrawal/details'
export const EP_GET_ACCOUNT_DETAIL = '/admin/get/getmargininfoex'
export const EP_WITHDRAWAL_REQUEST_OTP = '/withdrawal/request/otp'
export const EP_WITHDRAWAL_EMAIL_LINK = '/admin/commission/request/verify'
export const EP_RESEND_EMAIL_LINK = '/withdrawal/request/resend/otp'
export const EP_GET_WITHDRAWAL_METHODS = '/get/withdrawal/methods'
export const EP_GET_WITHDRAWAL_DESC = '/get/withdrawal/desc'

export const EP_GET_TRADING_LIST = '/admin/get/trading/list'
export const EP_GET_TRADING_VIEW = '/admin/get/trading/details'

export const EP_TICKET_REQUEST_OTP = '/ticket/request/otp'
export const EP_TICKET_CHECK_OTP = '/ticket/request'
export const EP_GET_TICKET_LIST = '/list/ticket'
export const EP_GET_TICKET_DETAIL = '/ticket/details'
export const EP_TICKET_REPLY = '/create/ticket/thread'
export const EP_GET_TICKET_REASON_LIST = '/get/ticket/reasons'
export const EP_TICKET_RESEND_OTP = '/ticket/request/otp/resend'

export const EP_GET_EMAIL_REFERRAL = '/get/referral'

// user sub ib list
export const EP_USER_SUBIB_LIST = '/admin/sub-ib/list'

export const EP_RESET_PASSWORD_FROM_HASH = '/change/via/forgot/password'

export const EP_GET_TRADING_ACCOUNT_LIST = '/admin/get/trading/list'
export const EP_GET_IB_TRADING_ACCOUNT_LIST = '/ib/get/trading/list'

export const EP_GET_USER_COMMISSION = '/admin/get/user/commission'


// WEBPACK FOOTER //
// ./src/store/api/endpoints.js